import { useSegmentsClient } from "@domains/segments/client/api/segmentsQuery.ts";
import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { useSession } from "@packages/core-client/session/SessionContext.tsx";
import { retryUnlessNotFound } from "@packages/core-client/query/retryUnlessNotFound.ts";
import { useQueries, type UseQueryResult } from "@tanstack/react-query";
import { useMemo } from "react";

function collectSegmentNames(results: UseQueryResult<{ id: string; name: string }>[]): Map<string, string> {
    const namesById = new Map<string, string>();

    for (const result of results) {
        if (result.data) {
            namesById.set(result.data.id, result.data.name);
        }
    }

    return namesById;
}

export function useSegmentLabels(segmentIds: string[]): Map<string, string> {
    const { queryUtils } = useSegmentsClient();
    const session = useSession();
    const organizationId = session?.organizationId ?? "";

    const ids = useMemo(() => [...new Set(segmentIds)].toSorted(), [segmentIds]);

    return useQueries({
        queries: ids.map(segmentId =>
            createQueryOptions(queryUtils.getSegment.queryOptions({ input: { orgId: organizationId, segmentId } }), {
                throwOnError: false,
                retry: retryUnlessNotFound
            })
        ),
        combine: collectSegmentNames
    });
}
